import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-64c6bff4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-wrapper" }
const _hoisted_2 = { class: "head-content" }
const _hoisted_3 = { class: "part-left" }
const _hoisted_4 = { class: "name-block" }
const _hoisted_5 = { class: "main-info" }
const _hoisted_6 = { class: "other-info" }
const _hoisted_7 = { class: "info-list" }
const _hoisted_8 = { class: "info-item" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "info-content" }
const _hoisted_11 = { class: "part-right" }
const _hoisted_12 = { class: "main-info" }
const _hoisted_13 = { class: "other-info" }
const _hoisted_14 = {
  key: 1,
  class: "cm-align-center cm-ui-mt15"
}
const _hoisted_15 = {
  key: 1,
  class: "cm-ui-ml10",
  style: {"color":"gray","font-size":"14px"}
}
const _hoisted_16 = {
  key: 2,
  class: "cm-ui-ml5",
  style: {"color":"gray","font-size":"14px"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "btn-group",
  style: {"margin-left":"auto"}
}, null, -1))
const _hoisted_18 = {
  key: 0,
  class: "leak-level"
}
const _hoisted_19 = {
  key: 1,
  class: "leak-level optional"
}
const _hoisted_20 = { class: "status" }

import { computed, onUnmounted, reactive, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { ElMessage } from 'element-plus'
import CmTable from '@/components/cmTable/index.vue'
import ContentAdaptLayout from '@/views/dashboard/_components/content-adapt-layout/content-adapt-layout.vue'
import PatchPopover from '@/views/dashboard/safe-status/vulnerability-fix/_components/patch-popover/patch-popover.vue'
import TerminalHead from '@/views/dashboard/group/client/terminal-info/terminal-head/terminal-head.vue'
import type { TableOpt } from '@/components/cmTable/types'
import {
  LeakTerminalService,
  RepairQueryParams,
  TLeakList,
} from '@/views/dashboard/safe-status/vulnerability-fix/_components/terminal-view-table/terminal-view-table.service'
import type { LeakTerminalList } from '@/views/dashboard/safe-status/vulnerability-fix/vulnerability-fix.service'
import type { PatchInfo } from '@/views/dashboard/safe-status/vulnerability-fix/vulnerability-fix.service'
import { VulnerabilityFixService } from '@/views/dashboard/safe-status/vulnerability-fix/vulnerability-fix.service'
import { LeakViewService } from '@/views/dashboard/safe-status/vulnerability-fix/_components/leak-view-table/leak-view-table.service'
import {
  ScanParams,
  ScanResult,
  TerminalItem,
  TerminalDrawerService,
} from '@/views/dashboard/safe-status/vulnerability-fix/_components/terminal-drawer/terminal-drawer.service'
import { TerminalType } from '@/views/dashboard/_enum/terminal-type'
import { login_status } from '@/views/dashboard/response-manage/response-handle/types'
import { useCmTableListRefresh, CmTableListRef } from '@/hooks/use-cm-table-list-refresh'
import { resolvedVirusKbDescription } from '@/utils/virus-kb-description'


export default /*#__PURE__*/_defineComponent({
  __name: 'repair-drawer',
  props: {
    showHeadInfo: { type: Boolean, default: true },
    currentTerminal: {}
  },
  emits: ["refresh"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { t, te, locale } = useI18n()

const injector = useReflectiveInjector([
  LeakViewService,
  VulnerabilityFixService,
  TerminalDrawerService,
  LeakTerminalService,
])
const leakViewService = injector.get(LeakViewService)
const mainService = injector.get(VulnerabilityFixService)
const termService = injector.get(TerminalDrawerService)
const leakTerminalService = injector.get(LeakTerminalService)

const tableRef = ref<
  (CmTableListRef & { tableRef?: { clearSelection: () => void } }) | null
>(null)
const { refreshList } = useCmTableListRefresh(tableRef)

const form = reactive({
  device_id: props.currentTerminal.device_id,
  is_high_risk: false,
})

const pageOption = {
  pageNumName: 'page',
  pageSizeName: 'limit',
}

const selectedRows = ref<TLeakList[]>([])
const patchInfo = ref<PatchInfo>({} as PatchInfo)
const scanTemInfo = ref<Partial<TerminalItem>>({})

const storedTaskId = localStorage.getItem('VULNERABILITY_SCAN_TSK_ID')
const scanResult = ref<ScanResult>({
  isFinish: !storedTaskId,
  success_count: 0,
  scan_total: 0,
})
const scanTskId = ref('')
if (storedTaskId) {
  scanTskId.value = storedTaskId
  scanResult.value = { isFinish: false, success_count: 0, scan_total: 0 }
}

const headLoginStatus = computed(
  () => props.currentTerminal.login_status ?? login_status.online,
)

const leakScanStatusI18n = computed(() => [
  t('safeProtectionModule.leakScanStatus0'),
  t('safeProtectionModule.leakScanStatus1'),
  t('safeProtectionModule.leakScanStatus2'),
  t('safeProtectionModule.leakScanStatus3'),
  t('safeProtectionModule.leakScanStatus4'),
])

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  const isLinux = props.currentTerminal.system_type === TerminalType.linux
  return {
    showActionBar: false,
    showSearch: false,
    showRightToolbar: false,
    height: '100%',
    path: 'list',
    totalPath: 'total',
    selection: !isLinux,
    rowKey: 'kb_number',
    bodyStyle:{padding: '15px'},
    reserveSelection: false,
    columns: [
      { prop: 'warn_level', label: t('safeProtectionModule.leakLevel'), minWidth: 100 },
      { prop: 'kb_number', label: t('safeProtectionModule.patchNumber'), columnOpt: { minWidth: 140 } },
      { prop: 'kb_pub_date', label: t('safeProtectionModule.patchPubDate'), minWidth: 160 },
      { prop: 'size', label: t('safeProtectionModule.patchSize'), minWidth: 100 },
      { prop: 'fix_status', label: t('safeProtectionModule.fixStatus'), minWidth: 130 },
      {
        prop: 'actions',
        label: t('safeProtectionModule.colOperation'),
        width: 90,
        columnOpt: { fixed: 'right' },
      },
    ],
  }
})

function formatKbLabel(kb: string | undefined | null) {
  const s = kb ?? ''
  if (!s) return '—'
  return s.includes('CVE-') ? s : `KB${s}`
}

function displayKbDesc(row: TLeakList) {
  void locale.value
  return resolvedVirusKbDescription(row.kb_number, te, t) ?? row.kb_desc ?? ''
}

const fixStatusMap = computed(() => ({
  0: t('safeProtectionModule.notRepaired'),
  1: t('safeProtectionModule.repairing'),
}))

function getListApi(params: Record<string, unknown>) {
  return leakTerminalService.getSingleTerminalLeaks({
    device_id: String(params.device_id ?? form.device_id),
    page: Number(params.page ?? 1),
    limit: Number(params.limit ?? 20),
    is_high_risk: Boolean(params.is_high_risk),
  })
}

function onChangeSelected(selection: TLeakList[]) {
  selectedRows.value = selection ?? []
}

function getPatchInfo(item: TLeakList & { patch_info?: PatchInfo }) {
  if (!item.kb_number) return
  if (item.patch_info) {
    patchInfo.value = item.patch_info
    return
  }
  void mainService.getPatchInfo({ kb_number: item.kb_number }).then((response) => {
    patchInfo.value = response.patch_info
    item.patch_info = response.patch_info
  })
}

async function getCurrentTem() {
  const result = await termService.getListByServer({
    device_list: [props.currentTerminal.device_id],
    group_id: props.currentTerminal.group_id,
    page: 1,
    limit: 1,
  })
  scanTemInfo.value = result.list[0] ?? {}
  await refreshList()
}

function handleScan() {
  scanTemInfo.value = {}
  const params: ScanParams = {
    select_type: 0,
    device_list: [props.currentTerminal.device_id],
    group_id: props.currentTerminal.group_id,
  }
  void termService.getLeakScan(params).then((res) => {
    localStorage.setItem('VULNERABILITY_SCAN_TSK_ID', res.task_id)
    scanResult.value.isFinish = false
    scanTskId.value = res.task_id
  })
}

let pollTimer: ReturnType<typeof setInterval> | undefined
watch(scanTskId, (id) => {
  if (pollTimer) {
    clearInterval(pollTimer)
    pollTimer = undefined
  }
  if (!id) return
  pollTimer = setInterval(() => {
    void termService.getScanResult({ task_id: id }).then((res) => {
      scanResult.value = res
      if (res.isFinish) {
        localStorage.removeItem('VULNERABILITY_SCAN_TSK_ID')
        if (pollTimer) {
          clearInterval(pollTimer)
          pollTimer = undefined
        }
        scanTskId.value = ''
        void getCurrentTem()
      }
    })
  }, 3000)
})

onUnmounted(() => {
  if (pollTimer) clearInterval(pollTimer)
})

function ignoreLeak(item: TLeakList) {
  if (!item.kb_number) return
  void leakViewService.ignoreLeak({ kb_numbers: [item.kb_number] }).then(() => {
    ElMessage.success(t('safeProtectionModule.ignoreLeakSuccess'))
    void refreshList()
  }).catch(() => {
    ElMessage.error(t('safeProtectionModule.ignoreLeakFail'))
  })
}

async function repairTer() {
  const kb_numbers = selectedRows.value.map((r) => r.kb_number).filter((x): x is string => Boolean(x))
  if (!kb_numbers.length) return
  const params: RepairQueryParams = {
    kb_numbers,
    select_type: 0,
    device_id: props.currentTerminal.device_id,
  }
  try {
    await leakTerminalService.RepairTerminal(params)
    ElMessage.success(t('safeProtectionModule.repairCmdSuccess'))
    emit('refresh')
    selectedRows.value = []
    tableRef.value?.tableRef?.clearSelection?.()
    await refreshList()
  } catch {
    ElMessage.error(t('safeProtectionModule.repairCmdFail'))
  }
}

watch(
  () => props.currentTerminal.device_id,
  async (id, prev) => {
    if (!id) return
    form.device_id = id
    if (prev !== undefined && id !== prev) {
      scanTemInfo.value = {}
      selectedRows.value = []
      tableRef.value?.tableRef?.clearSelection?.()
      await refreshList()
    }
  },
  { immediate: true },
)

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_date_format = _resolveDirective("date-format")!

  return (_openBlock(), _createBlock(CmTable, {
    ref_key: "tableRef",
    ref: tableRef,
    modelValue: form,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form) = $event)),
    "table-opt": tableOpt.value,
    api: getListApi,
    "page-option": pageOption,
    onChangeSelected: onChangeSelected
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.showHeadInfo)
          ? (_openBlock(), _createBlock(TerminalHead, {
              key: 0,
              "system-type": _ctx.currentTerminal.system_type,
              "login-status": headLoginStatus.value
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.currentTerminal.computer_name || _ctx.$t('safeProtectionModule.terminalUnnamed')), 1),
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.currentTerminal.os || '—'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('safeProtectionModule.detectTime')), 1),
                        _createElementVNode("div", _hoisted_10, [
                          _withDirectives(_createElementVNode("span", null, null, 512), [
                            [_directive_date_format, { value: _ctx.currentTerminal.scan_time * 1000 }]
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.currentTerminal.user_mark || '—'), 1),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.currentTerminal.group_name), 1)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["system-type", "login-status"]))
          : _createCommentVNode("", true),
        (_ctx.currentTerminal.system_type !== _unref(TerminalType).linux)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                disabled: !selectedRows.value.length,
                onClick: repairTer
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.repairLeakBtn')), 1)
                ]),
                _: 1
              }, 8, ["disabled"]),
              (!_ctx.showHeadInfo)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    plain: "",
                    loading: !scanResult.value.isFinish,
                    size: "small",
                    onClick: handleScan
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scanResult.value.isFinish
                ? _ctx.$t('safeProtectionModule.startScan')
                : _ctx.$t('safeProtectionModule.scanWaiting', {
                  done: scanResult.value.success_count,
                  total: scanResult.value.scan_total,
                })), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"]))
                : _createCommentVNode("", true),
              (scanTemInfo.value.last_scan_time)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.$t('safeProtectionModule.scanResultWithColon')) + _toDisplayString(leakScanStatusI18n.value[scanTemInfo.value.scan_status ?? 0]), 1))
                : _createCommentVNode("", true),
              (scanTemInfo.value.last_scan_time)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.lastScanTimeWithColon')) + " ", 1),
                    _withDirectives(_createElementVNode("span", null, null, 512), [
                      [_directive_date_format, { value: (scanTemInfo.value.last_scan_time as number) * 1000 }]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_17
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    warn_level: _withCtx(({ row }) => [
      (row.warn_level)
        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t('safeProtectionModule.leakHigh')), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t('safeProtectionModule.leakOptional')), 1))
    ]),
    kb_number: _withCtx(({ row }) => [
      _createVNode(PatchPopover, {
        "patch-info": patchInfo.value,
        "warn-level": row.warn_level,
        "description-fallback": displayKbDesc(row),
        "pub-date-fallback": row.kb_pub_date
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "text",
            class: "kb_number",
            "data-test": "kb_number",
            onMouseenter: ($event: any) => (getPatchInfo(row))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(formatKbLabel(row.kb_number)), 1)
            ]),
            _: 2
          }, 1032, ["onMouseenter"])
        ]),
        _: 2
      }, 1032, ["patch-info", "warn-level", "description-fallback", "pub-date-fallback"])
    ]),
    fix_status: _withCtx(({ row }) => [
      _createElementVNode("span", _hoisted_20, _toDisplayString(fixStatusMap.value[row.fix_status] ?? '—'), 1)
    ]),
    actions: _withCtx(({ row }) => [
      _createVNode(_component_el_button, {
        class: "active_text",
        type: "text",
        onClick: ($event: any) => (ignoreLeak(row))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.ignoreLeakBtn')), 1)
        ]),
        _: 2
      }, 1032, ["onClick"])
    ]),
    _: 1
  }, 8, ["modelValue", "table-opt"]))
}
}

})